<div class="node-icon visiting">
	<span class="node-icon-connector"></span>
</div>
